import { Mountain, UtensilsCrossed, HeartHandshake, Wallet } from "lucide-react";

const PILLARS = [
  { icon: Mountain, title: "Location & Views", text: "Deep in the woods, wrapped in birdsong and mountain air." },
  { icon: HeartHandshake, title: "Personal Service", text: "Hospitality that remembers your name and your morning tea." },
  { icon: Wallet, title: "Honest Value", text: "A retreat that feels indulgent, priced so you can return." },
  { icon: UtensilsCrossed, title: "Food & Experiences", text: "Forest-side dining, trails, bonfires and days well spent." },
];

export const Welcome = () => {
  return (
    <section data-testid="welcome-section" className="watercolor-section py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C5A880]">Welcome</p>
          <h2 className="font-serif-display font-light text-3xl md:text-4xl lg:text-5xl tracking-tight text-[#0B3B39] mt-4 leading-tight">
            Nestled deep in the woods, made for slowing down.
          </h2>
          <p data-testid="welcome-intro-text" className="text-base md:text-lg leading-relaxed text-[#4A5568] mt-6">
            Resort The Forest is a single, secluded retreat where great views, personal service and honest value come
            together — welcoming families on vacation, couples, travellers and corporate retreats alike.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mt-16">
          {PILLARS.map((p) => (
            <div key={p.title} data-testid={`pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group">
              <p.icon className="w-8 h-8 text-[#0B3B39] group-hover:text-[#C5A880] transition-colors duration-300" strokeWidth={1.5} />
              <h3 className="font-serif-display text-xl text-[#0B3B39] mt-4">{p.title}</h3>
              <p className="text-sm leading-relaxed text-[#4A5568] mt-2">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
